// Canvas + board geometry. The canvas is square; the board sits centred with
// a gutter on every side — the top one holds the turn banner, the bottom one
// the clocks.
export const CANVAS_SIZE = 720;
export const BOARD_OUTER_SIZE = 640;
export const BOARD_OUTER_OFFSET = (CANVAS_SIZE - BOARD_OUTER_SIZE) / 2;
export const WOOD_FRAME_THICKNESS = 32;
export const BOARD_INLAY_OFFSET = BOARD_OUTER_OFFSET + WOOD_FRAME_THICKNESS;
export const BOARD_INLAY_SIZE = BOARD_OUTER_SIZE - 2 * WOOD_FRAME_THICKNESS;
export const SQUARE_SIZE = BOARD_INLAY_SIZE / 8;

/** Piece artwork is authored in a 100×100 box and scaled to this share of a square. */
export const PIECE_SCALE = 0.9;

// Animation timings (ms).
export const PIECE_MOVE_DURATION_MS = 220;
export const PIECE_FADE_DURATION_MS = 180;

// Overlay.
export const HOVER_GLOW_BLUR = 14;
export const GHOST_PIECE_ALPHA = 0.45;
export const LEGAL_DOT_RADIUS = SQUARE_SIZE * 0.16;
export const CAPTURE_RING_WIDTH = SQUARE_SIZE * 0.08;
/** Dragged piece is drawn a little larger than a resting one. */
export const DRAG_SCALE = 1.12;
